export default require('../../client/birth/ReviewRequestPage').default;
